define('home/views/common/FetchableCollectionFooterView',[
    'underscore',
    'backbone-marionette',

    'home/templates/spinner',
    'home/templates/moreButton',
    'home/templates/endOfItems',
    'home/templates/loadError',
], function (
    _,
    Marionette,

    spinnerTemplate,
    moreButtonTemplate,
    endOfItemsTemplate,
    loadErrorTemplate
) {
    'use strict';

    /**
     * A footer for a paginated collection. Intended to be used in conjunction with a
     * FetchableCollectionView.
     *
     * Footer shows the more button and end of items message for non-empty collections.
     * It will also show the spinner when fetching items subsequent to the initial fetch.
     * (Initial fetch state is handled by the FetchableCollectionView).
     *
     * Can extend class and override endOfItemsTemplate to change the message shown when
     * the feed runs out. Doing this will still cause the spinner/more buttons to show at
     * the correct times
     */
    var FetchableCollectionFooterView = Marionette.ItemView.extend({
        endOfItemsTemplate: endOfItemsTemplate,
        errorTemplate: loadErrorTemplate,

        template: function (data) {
            // FetchableCollectionView should be showing all (if any) items
            // fetched before the error occurred. Show the error state.
            if (data.error)
                return this.errorTemplate(data);

            // FetchableCollectionView should be showing the fetching state
            // for initial fetch, or the empty view state once fetch is complete.
            // Show nothing.
            if (!this.collection.length)
                return '';

            if (data.fetching)
                return spinnerTemplate(data);

            if (data.hasNext)
                return moreButtonTemplate(data);

            return this.endOfItemsTemplate(data);
        },

        className: 'more-wrapper',

        events: {
            'click [data-action=more-feed]': 'moreClicked',
        },
        modelEvents: {
            'change:fetching': 'render',
        },

        initialize: function () {
            this.template = _.bind(this.template, this);
        },

        moreClicked: function (evt) {
            evt.preventDefault();
            this.model.fetchItems();
        },
    });

    return FetchableCollectionFooterView;
});

